// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__35vdU","info_profile":"header_info_profile__3etBm","rating":"header_rating__3KJMb","star_icon":"header_star_icon__2tZQt"};